/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * * `EUR` - Eur
 * * `MDL` - Mdl
 * * `USD` - Usd
 */
export enum CurrencyE67Enum {
  EUR = 'EUR',
  MDL = 'MDL',
  USD = 'USD',
}
